import apiClient from '../../../lib/axios';

const buildParams = (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.isActive !== undefined) params.append('isActive', filters.isActive);
  if (filters.search) params.append('search', filters.search);
  if (filters.page) params.append('page', filters.page);
  if (filters.limit) params.append('limit', filters.limit);
  return params;
};

// Education Levels
export const fetchEducationLevels = async (filters = {}) => {
  const params = buildParams(filters);
  const response = await apiClient.get(`/api/demographics/education-levels?${params.toString()}`);
  return response.data;
};

export const createEducationLevel = async (payload) => {
  const response = await apiClient.post('/api/demographics/education-levels', payload);
  return response.data;
};

export const updateEducationLevel = async ({ id, payload }) => {
  const response = await apiClient.patch(`/api/demographics/education-levels/${id}`, payload);
  return response.data;
};

export const deleteEducationLevel = async (id) => {
  const response = await apiClient.delete(`/api/demographics/education-levels/${id}`);
  return response.data;
};

// Marital Statuses
export const fetchMaritalStatuses = async (filters = {}) => {
  const params = buildParams(filters);
  const response = await apiClient.get(`/api/demographics/marital-statuses?${params.toString()}`);
  return response.data;
};

export const createMaritalStatus = async (payload) => {
  const response = await apiClient.post('/api/demographics/marital-statuses', payload);
  return response.data;
};

export const updateMaritalStatus = async ({ id, payload }) => {
  const response = await apiClient.patch(`/api/demographics/marital-statuses/${id}`, payload);
  return response.data;
};

export const deleteMaritalStatus = async (id) => {
  const response = await apiClient.delete(`/api/demographics/marital-statuses/${id}`);
  return response.data;
};

// Vulnerabilities
export const fetchVulnerabilities = async (filters = {}) => {
  const params = buildParams(filters);
  const response = await apiClient.get(`/api/demographics/vulnerabilities?${params.toString()}`);
  return response.data;
};

export const createVulnerability = async (payload) => {
  const response = await apiClient.post('/api/demographics/vulnerabilities', payload);
  return response.data;
};

export const updateVulnerability = async ({ id, payload }) => {
  const response = await apiClient.patch(`/api/demographics/vulnerabilities/${id}`, payload);
  return response.data;
};

export const deleteVulnerability = async (id) => {
  const response = await apiClient.delete(`/api/demographics/vulnerabilities/${id}`);
  return response.data;
};

// Disabilities
export const fetchDisabilities = async (filters = {}) => {
  const params = buildParams(filters);
  const response = await apiClient.get(`/api/demographics/disabilities?${params.toString()}`);
  return response.data;
};

export const createDisability = async (payload) => {
  const response = await apiClient.post('/api/demographics/disabilities', payload);
  return response.data;
};

export const updateDisability = async ({ id, payload }) => {
  const response = await apiClient.patch(`/api/demographics/disabilities/${id}`, payload);
  return response.data;
};

export const deleteDisability = async (id) => {
  const response = await apiClient.delete(`/api/demographics/disabilities/${id}`);
  return response.data;
};

// Employment Statuses
export const fetchEmploymentStatuses = async (filters = {}) => {
  const params = buildParams(filters);
  const response = await apiClient.get(`/api/demographics/employment-statuses?${params.toString()}`);
  return response.data;
};

export const createEmploymentStatus = async (payload) => {
  const response = await apiClient.post('/api/demographics/employment-statuses', payload);
  return response.data;
};

export const updateEmploymentStatus = async ({ id, payload }) => {
  const response = await apiClient.patch(`/api/demographics/employment-statuses/${id}`, payload);
  return response.data;
};

export const deleteEmploymentStatus = async (id) => {
  const response = await apiClient.delete(`/api/demographics/employment-statuses/${id}`);
  return response.data;
};

// Employments
export const fetchEmployments = async (filters = {}) => {
  const params = buildParams(filters);
  if (filters.employmentStatus) params.append('employmentStatus', filters.employmentStatus);
  const response = await apiClient.get(`/api/demographics/employments?${params.toString()}`);
  return response.data;
};

export const createEmployment = async (payload) => {
  const response = await apiClient.post('/api/demographics/employments', payload);
  return response.data;
};

export const updateEmployment = async ({ id, payload }) => {
  const response = await apiClient.patch(`/api/demographics/employments/${id}`, payload);
  return response.data;
};

export const deleteEmployment = async (id) => {
  const response = await apiClient.delete(`/api/demographics/employments/${id}`);
  return response.data;
};

// Income Levels
export const fetchIncomeLevels = async (filters = {}) => {
  const params = buildParams(filters);
  const response = await apiClient.get(`/api/demographics/income-levels?${params.toString()}`);
  return response.data;
};

export const createIncomeLevel = async (payload) => {
  const response = await apiClient.post('/api/demographics/income-levels', payload);
  return response.data;
};

export const updateIncomeLevel = async ({ id, payload }) => {
  const response = await apiClient.patch(`/api/demographics/income-levels/${id}`, payload);
  return response.data;
};

export const deleteIncomeLevel = async (id) => {
  const response = await apiClient.delete(`/api/demographics/income-levels/${id}`);
  return response.data;
};

// Age Groups
export const fetchAgeGroups = async (filters = {}) => {
  const params = buildParams(filters);
  const response = await apiClient.get(`/api/demographics/age-groups?${params.toString()}`);
  return response.data;
};

export const createAgeGroup = async (payload) => {
  const response = await apiClient.post('/api/demographics/age-groups', payload);
  return response.data;
};

export const updateAgeGroup = async ({ id, payload }) => {
  const response = await apiClient.patch(`/api/demographics/age-groups/${id}`, payload);
  return response.data;
};

export const deleteAgeGroup = async (id) => {
  const response = await apiClient.delete(`/api/demographics/age-groups/${id}`);
  return response.data;
};

// Titles
export const fetchTitles = async (filters = {}) => {
  const params = buildParams(filters);
  const response = await apiClient.get(`/api/demographics/titles?${params.toString()}`);
  return response.data;
};

export const createTitle = async (payload) => {
  const response = await apiClient.post('/api/demographics/titles', payload);
  return response.data;
};

export const updateTitle = async ({ id, payload }) => {
  const response = await apiClient.patch(`/api/demographics/titles/${id}`, payload);
  return response.data;
};

export const deleteTitle = async (id) => {
  const response = await apiClient.delete(`/api/demographics/titles/${id}`);
  return response.data;
};

// Sex
export const fetchSexes = async (filters = {}) => {
  const params = buildParams(filters);
  const response = await apiClient.get(`/api/demographics/sexes?${params.toString()}`);
  return response.data;
};

export const createSex = async (payload) => {
  const response = await apiClient.post('/api/demographics/sexes', payload);
  return response.data;
};

export const updateSex = async ({ id, payload }) => {
  const response = await apiClient.patch(`/api/demographics/sexes/${id}`, payload);
  return response.data;
};

export const deleteSex = async (id) => {
  const response = await apiClient.delete(`/api/demographics/sexes/${id}`);
  return response.data;
};
